import { render, staticRenderFns } from "./VirtualDeviceEdit.vue?vue&type=template&id=06f10bef&scoped=true&"
import script from "./VirtualDeviceEdit.vue?vue&type=script&lang=js&"
export * from "./VirtualDeviceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f10bef",
  null
  
)

export default component.exports